module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "loading-main"
  }, [_c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "loading-gif animation_x"
  }), _vm._v(" "), _c('p', [_vm._v("loading...")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e63ee7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading/index.vue
// module id = 200
// module chunks = 0